var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpSideFillAngleBracket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.87932 5.80364C9.75974 5.75037 9.63029 5.72285 9.49938 5.72285C9.36847 5.72285 9.23903 5.75037 9.11945 5.80364L5.39295 7.4635C4.50105 7.92009 3.98811 6.97449 4.43684 6.3967C5.26954 5.32451 7.77559 2.60792 8.91913 1.37787C8.99327 1.2981 9.08306 1.23447 9.1829 1.19097C9.28274 1.14746 9.39048 1.125 9.49938 1.125C9.60829 1.125 9.71603 1.14746 9.81586 1.19097C9.9157 1.23447 10.0055 1.2981 10.0796 1.37787C11.2232 2.60792 13.7292 5.32451 14.5619 6.3967C15.0218 6.9888 14.4811 7.91157 13.6058 7.4635L9.87932 5.80364Z",
    fill: "#B4C0C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpSideFillAngleBracket);
export default __webpack_public_path__ + "static/media/upSideFillAngleBracket.aab23fa4b3c28bb04bf38d73613cf7ff.svg";
export { ForwardRef as ReactComponent };